import * as React from 'react';
import { useSelector } from 'react-redux';
import { Bank } from '../../components/Bank';
import { Banks as BanksComponent } from '../../components/Banks';
import { getBanks, getDisplayName } from '../../selectors/newbuilding';
import { trackBankClick } from './tracking';

export const Banks = () => {
  const banks = useSelector(getBanks);
  const name = useSelector(getDisplayName);

  if (!banks || !banks.length) {
    return null;
  }

  return (
    <BanksComponent title={`${name} — ипотека от банков`} mortgageUrl={'https://www.cian.ru/ipoteka-main'}>
      {banks.map(bank => (
        <Bank key={bank.searchUrl} {...bank} onClick={trackBankClick} />
      ))}
    </BanksComponent>
  );
};

Banks.displayName = 'Banks';
